export const entriesAdd = "[Entries] Add";

export const entriesAddError = "[Entries] Add Error";

export const authSignIn = "[Auth] Sign In";

export const authSignInError = "[Auth] Sign In Error";

export const authSignOut = "[Auth] Sign Out";

export const entriesList = "[Entries] List";

export const entriesListDone = "[Entries] List Done";

export const entriesListError = "[Entries] List Error";
